import { useCallback, useEffect, useState } from 'react';

export function useCountDownTimer({
  timer,
  interval = 1000,
  autostart = false,
  expireImmediate = false,
  onExpire,
  onReset,
}) {
  const [countdown, setCountdown] = useState(timer);
  const [canStart, setCanStart] = useState(autostart);

  function start() {
    setCanStart(true);
  }

  const reset = useCallback(() => {
    setCanStart(false);
    setCountdown(timer);

    if (onReset && typeof onReset === 'function') {
      onReset();
    }
  }, [timer, onReset]);

  const expire = useCallback(() => {
    setCanStart(false);
    setCountdown(timer);

    if (onExpire && typeof onExpire === 'function') {
      onExpire();
    }
  }, [timer, onExpire]);

  useEffect(() => {
    let id;
    let startDate;

    function tick() {
      const remained = timer - Math.floor((Date.now() - startDate) / 1000);
      if (remained <= 0) {
        expire();
      } else {
        setCountdown(remained);
      }
    }

    if (canStart) {
      startDate = Date.now();
      id = setInterval(tick, interval);
    }
    return () => clearInterval(id);
  }, [expire, canStart, interval, expireImmediate, timer]);

  return {
    countdown,
    start,
    reset,
    canStart,
  };
}

export default useCountDownTimer;
